import {
  CssBaseline,
  CssVarsProvider,
  // GlobalStyles,
  fortressV2Theme,
} from "@castlery/fortress";
import { EnhancedErrorBoundary } from "./components/ErrorBoundary";
import { CasaSwitcher } from "./modules/casa/components/CasaSwitcher";

function App() {
  return (
    <EnhancedErrorBoundary
      timeWindow={2 * 60 * 1000} // 2 分钟时间窗口
      errorThreshold={5} // 5 次错误阈值
      disableOnThreshold={true} // 不自动禁用，只警告
      onThresholdReached={(errors) => {
        // 达到阈值时的处理逻辑

        // 可以在这里执行特定操作，比如：
        // 1. 发送错误报告到监控系统
        // 2. 显示特殊的用户提示
        // 3. 切换到降级模式
        // 4. 记录用户行为数据

        window.__CASA_INSTANCE__?.emit?.("runtime:error", errors);
      }}
    >
      <CssVarsProvider theme={fortressV2Theme}>
        <CssBaseline />
        {/* <GlobalStyles /> */}
        <CasaSwitcher />
      </CssVarsProvider>
    </EnhancedErrorBoundary>
  );
}

export default App;
